export default __webpack_public_path__ + "static/media/gift_hoichoi_logo.856bd23f.png";